import React from "react";
import styles from "./Copyright.module.scss";

const Copyright: React.FC = () => {
  return (
    <div className={styles.footerCopyright}>
      <p className={styles.footerCopyrightText}>
        Информация на сайте носит ознакомительный характер и не может служить
        заменой очной консультации врача.
      </p>
    </div>
  );
};

export default Copyright;
